<div class="query-builder-main">
  <div *ngFor="let rule of query.rules; let ruleIndex = index" [ngSwitch]="rule.type">
    <div *ngSwitchCase="PARAMETER_SET_NODE">
      <div *ngIf="ruleIndex > 0" class="rule-set-condition">
        <p-radioButton class="new-radio-button-skin-and" (ngModelChange)=" logicalOperatorChanged($event)"
                       value="and" label="AND" [(ngModel)]="query.condition"></p-radioButton>
        <p-radioButton class="new-radio-button-skin-or" (ngModelChange)=" logicalOperatorChanged($event)"
                       value="or" label="OR" [(ngModel)]="query.condition"></p-radioButton>
      </div>
      <div [ngClass]="{'child-wrapper-and': query.condition == 'and' && query.rules.length > 1,
                        'child-wrapper-or': query.condition == 'or' && query.rules.length > 1}"
           class="child-wrapper">
        <div [ngClass]="{'border-left-and': query.condition == 'and' && query.rules.length > 1,
                        'border-left-or': query.condition == 'or' && query.rules.length > 1}"
              class="border-left">
          <div class="delete-set">
            <gen-button class="action expand-collapse-rule"
                        (click)="deleteRule(rule)"
                        [type]="'quite'"
                        [text]="''"
                        [iconClass]="'icon__Cross2'"
                        [disabled]="query.rules.length === 1">
            </gen-button>
          </div>
        </div>
        <div class="query-builder-wrapper">
          <query-builder class="query-builder" [query]="rule" [config]="config" [currentLevel]="currentLevel + 1" (validateChange)="updateValidity(rule, $event)"></query-builder>
        </div>
      </div>
    </div>
    <div *ngSwitchCase="PARAMETER_NODE">
      <div class="parameter-node">
        <div *ngIf="ruleIndex > 0"
             [ngClass]="{'vertical-line-or': query.condition == 'or', 'vertical-line-and': query.condition == 'and'}"
             class="vertical-line">
          <div class="and-or-wrapper">
            <p-radioButton class="new-radio-button-skin-and" (ngModelChange)=" logicalOperatorChanged($event)"
                           value="and" label="AND" [(ngModel)]="query.condition"></p-radioButton>
            <p-radioButton class="new-radio-button-skin-or" (ngModelChange)=" logicalOperatorChanged($event)"
                           value="or" label="OR" [(ngModel)]="query.condition"></p-radioButton>
          </div>
        </div>
      </div>
      <p-panel class="parameter-panel"
               [ngClass]="{'parameter-panel-empty': !rule.parameter,
                           'parameter-panel-and': query.condition == 'and' && query.rules.length > 1,
                           'parameter-panel-or': query.condition == 'or' && query.rules.length > 1}"
               [toggleable]="true"
               [collapsed]="rule['collapsed']!==undefined ? rule['collapsed'] : false"
               #panel>
        <p-header>
          <div class="header-wrapper">
            <select deep-blur class="parameter-select form-control dynamic_form_item_selector"
                    [(ngModel)]="rule.parameter"
                    [ngClass]="{'negated-parameter': rule.negate}"
                    (change)="selectRule(rule)">
              <option [ngValue]="null"></option>
              <option *ngFor="let parameter of parameters" [ngValue]="parameter.key">{{parameter.name + (rule.negate ? ' (not)' : '')}}</option>
            </select>
            <div class="header-actions">
              <gen-button class="negate-parameter-toggle"
                          [ngClass]="{'negated-parameter': rule.negate}"
                          (click)="toggleNegation(rule)"
                          [type]="'quite'"
                          [text]="'Negation'">
              </gen-button>
              <div class="additional-actions">
                <gen-button class="action delete-rule"
                            (click)="deleteRule(rule)"
                            [type]="'quite'"
                            [text]="''"
                            [iconClass]="'icon__Cross2'"
                            [disabled]="query.rules.length === 1">
                </gen-button>
                <gen-button class="action expand-collapse-rule"
                            (click)="expandCollapsePanel($event, panel, rule)"
                            [type]="'quite'"
                            [text]="''"
                            [iconClass]="panel.collapsed ? 'icon__NavigationLeft1' : 'icon__NavigationDown2'"
                            [disabled]="!rule.parameter">
                </gen-button>
              </div>
            </div>
          </div>
        </p-header>
        <div *ngIf="rule.parameter">
          <gen-dynamic-form
            class="dynamic-form-table"
            [formData]="rule"
            (formChange)="onParameterRulesChanged(rule, $event.form)"
            [formName]="config.queriables[rule.parameter].formName"
            [editMode]="false"
            [disabled]="false"
            [formItemFullWidth]="true"
            (validateChange)="updateValidity(rule, $event)"
          ></gen-dynamic-form>
        </div>
      </p-panel>
    </div>
  </div>
  <div class="actions-container">
    <div *ngIf="currentLevel < (config.maxLevel - 1)"
         class="button-add-parameter-set"
         (click)="addParameterSet(query)">
      <div class="Flexbox">
        <span class="icon Flexbox addParamImg icon__add-parameter"><span class="path1"></span><span class="path2"></span></span>
        <span class="text addPrameterTxt">Add Parameter Set</span>
      </div>
    </div>
    <div *ngIf="canAddParameter(query)"
         class="button-add-parameter"
         (click)="addParameter(query)">
      <div class="Flexbox">
        <span class="icon Flexbox addParamImg icon__add-parameter-set"><span class="path1"></span><span class="path2"></span></span>
      <span class="text">Add Parameter</span>
      </div>
    </div>
  </div>
</div>


